import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import config from '../../../../config.json';
import './PersonInfo.css';
import { changeStatusPersonById } from './../../../../service/personService';
import { getItemComments } from '../../../../service/commentService';
import Commnets from '../../comment/ItemComments';

const PersonInfo = () => {
    const { state } = useLocation();
    const [person, setPerson] = useState(state.person);
    const {addToast} = useToasts();
    const history = useHistory();
    const [changeModeLoading, setChangeModeLoading] = useState(false);
    const [lastCommentId, setLastCommentId] = useState(''); 
    const [comments, setComments] = useState(); 
    const [commentsLoading, setCommentsLoading] = useState(false);

    const changeModeHandler = async (userId) => {
        try {
            setChangeModeLoading(true);
            const { status } = await changeStatusPersonById(userId);
            if (status === 201) {
                addToast("تغییر وضعیت کاربر انجام شد", {
                    appearance: 'success',
                    autoDismiss: true,
                })
                let oldPerson = {...person};
                oldPerson.vip = Boolean(oldPerson.vip) === true ? false : true;
                setPerson(oldPerson);
                setChangeModeLoading(false);
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                addToast("عدم دسترسی مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/login');
            }
            else if (err.response && err.response.status === 404) {
                addToast("چنین کاربری  وجود ندارد !", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/dashboard/questions')
            }
        }
    }

    const getPersonCommentsHandler = async (userId) => {
        try {
            setCommentsLoading(true);
            const params = {
                itemType: 'person',
                itemId: userId,
                lastCommentId: lastCommentId,
                commentsStatus: ''
            }
            const { status, data } = await getItemComments(params);
            if (status === 201) {
                if(data.comments.length){
                    const oldComments = comments ? [...comments] : [];
                    const newComments = oldComments.concat(data.comments)
                    setComments(newComments)
                    setLastCommentId(newComments[newComments.length - 1]._id);
                }
                setCommentsLoading(false);
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                addToast("عدم دسترسی مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/login');
            }
        }
    }


    return ( 
        <React.Fragment>
            <div className="person-information-layer">
                <header>
                    <h1>اطلاعات متخصص</h1>
                </header>
                <section className="mb-3 d-flex flex-wrap justify-content-center align-items-baseline">
                    <span className="image-circle mt-2 mb-3 align-self-center text-center col-12">
                        <img src={`${config.api_server}/${person.personImage}`} alt="" className="" />
                    </span>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">نام و نام خانوادگی</span>
                        <span className="mx-1">:</span>
                        <span>{person.fullName}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">کد</span>
                        <span className="mx-1">:</span>
                        <span>{person.code}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">دسته بندی شغلی</span>
                        <span className="mx-1">:</span>
                        <span>{person.jobCategoryName}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">حرفه</span>
                        <span className="mx-1">:</span>
                        <span>{person.vocation}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">توضیحات</span>
                        <span className="mx-1">:</span>
                        <span>{person.vocationInfo}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">شروع همکاری</span>
                        <span className="mx-1">:</span>
                        <span style={{direction:'ltr', textAlign:'left'}}>{person.handshakeDate}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">تعداد همکاری</span>
                        <span className="mx-1">:</span>
                        <span>{person.handshakeCount}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">شماره موبایل</span>
                        <span className="mx-1">:</span>
                        <span>{person.mobileNumber}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">سن</span>
                        <span className="mx-1">:</span>
                        <span>{person.age}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">شماره ثابت</span>
                        <span className="mx-1">:</span>
                        <span>{person.telephone}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">آدرس</span>
                        <span className="mx-1">:</span>
                        <span>{person.address}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">محدوده</span>
                        <span className="mx-1">:</span>
                        <span>{person.areaName}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">نمره از 5</span>
                        <span className="mx-1">:</span>
                        <span className="badge badge-warning badge-pill">{person.score}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">سفارشات</span>
                        <span className="mx-1">:</span>
                        <span className="badge badge-primary badge-pill">{person.orders}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">نظرات</span>
                        <span className="mx-1">:</span>
                        <span className="badge badge-dark badge-pill">{person.comments}</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">تخفیف به مشتری</span>
                        <span className="mx-1">:</span>
                        <span>% {person.discountPercent} کمتر از قیمت نرخ نامه</span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <span className="font-weight-bold">vip</span>
                        <span className="mx-1">:</span>
                        <span className={person.vip === true ? 'text-success' : 'text-danger'}>
                            {person.vip === true ? 'بله' : 'خیر'}
                        </span>
                    </div>
                    <div className="my-1 my-sm-2 col-12 col-sm-6 col-md-4 col-xl-3">
                        <button className="btn btn-primary mr-1 mr-md-0  mb-md-1 "
                            onClick={() => changeModeHandler(person._id)}
                            disabled={changeModeLoading}
                        >
                            <i 
                                className={changeModeLoading ? 'spinner-border spinner-border-sm mr-2': ''} 
                                style={{position:'relative', bottom:'2px'}}
                            ></i>
                            تغییر وضعیت vip
                            
                        </button>
                    </div>
                    <div className="my-2 col-12 item-comments-layer">
                        {
                            comments &&
                            <h5><span>نظرات</span></h5>
                        }
                        {
                            (comments && comments.length)  &&
                            <Commnets comments={comments}/> 
                        }
                        {
                            (comments && !comments.length)  &&
                            <div className="d-flex justify-content-center" style={{minHeight: '100px'}}>
                                <h6 className="align-self-center font-weight-bold">هیچ نظری تا کنون ثبت نشده است</h6>
                            </div>
                        }
                        <button className="btn btn-success mr-1 mr-md-0  mb-md-1 "
                            onClick={() => getPersonCommentsHandler(person._id)}
                            disabled={commentsLoading}
                        >
                            <i 
                                className={commentsLoading ? 'spinner-border spinner-border-sm mr-2': ''} 
                                style={{position:'relative', bottom:'2px'}}
                            ></i>
                            {(comments && comments.length) ? 'مشاهده بیشتر' : 'مشاهده نظرات'} 
                        </button>
                    </div>
                </section>
            </div>
        </React.Fragment>
    );
}
 
export default PersonInfo;